import React from 'react'

function Footer() {
    return (
        <>
            <div className="yoc-footer yoc-grid__item yoc-grid yoc-grid--desyocop yoc-grid--ver-desyocop"
                id="yoc_footer">
                <div className="yoc-container yoc-container--fluid">
                    <div className="yoc-footer__copyright align-items-center">
                        <img className="img-fluid" src="assets/media/Questopedia-sm.svg" />
                        2022&nbsp;&copy;&nbsp;<a href="http://www.yoctel.com/" target="_blank"
                            className="yoc-link">Yoctel Solutions Pvt. Ltd.</a>
                    </div>
                    <div className="yoc-footer__menu">
                        <a href="#" target="_blank" className="yoc-footer__menu-link yoc-link">About</a>
                        <a href="#" target="_blank" className="yoc-footer__menu-link yoc-link">Team</a>
                        <a href="#" target="_blank" className="yoc-footer__menu-link yoc-link">Contact</a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer